import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES, SERVICES } from "@/data/site";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { CTABanner } from "@/components/sections";
import ServiceCards from "@/components/ServiceCards";
import { BookButton } from "@/components/CTAButtons";

export default function ServicesMenu() {
  return (
    <>
      <SEO
        title="Services & Price Menu — Hair, Nails, Facials & Waxing in Hell's Kitchen"
        description="Explore the full Maison Neuf service menu and transparent pricing for hair color, balayage, manicures, facials, HydraFacial, waxing, brows and lashes in Hell's Kitchen, NYC."
      />
      <section className="mx-auto max-w-[1400px] px-5 pt-36 pb-16 md:px-10 md:pt-44" data-testid="services-intro">
        <Reveal>
          <p className="label mb-6 text-wine">Services & Menu</p>
          <h1 className="max-w-4xl font-display text-5xl leading-[1.02] md:text-8xl">Everything, under one roof.</h1>
          <p className="mt-8 max-w-xl text-muted-foreground md:text-lg">
            Four specialist studios in one Hell's Kitchen address. Browse the categories, then dive into transparent pricing on each page.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-10">
        <ServiceCards />
      </section>

      {/* FULL PRICING MENU */}
      <section className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32" data-testid="full-price-menu">
        {CATEGORIES.map((c) => {
          const s = SERVICES[c.slug];
          return (
            <div key={c.slug} className="mb-20 last:mb-0">
              <Reveal>
                <div className="flex flex-col justify-between gap-4 border-b border-foreground/20 pb-6 md:flex-row md:items-end">
                  <div>
                    <p className="label mb-3 text-wine">{s.kicker}</p>
                    <h2 className="font-display text-3xl md:text-5xl">{c.name}</h2>
                  </div>
                  <Link to={c.path} className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.16em] text-foreground/80 hover:text-foreground link-underline">
                    Full details <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
                  </Link>
                </div>
              </Reveal>
              <div>
                {s.menu.map((m, i) => (
                  <Reveal key={i}>
                    <div className="grid grid-cols-12 items-baseline gap-4 border-b border-border py-5">
                      <div className="col-span-8 md:col-span-9">
                        <h3 className="font-display text-lg md:text-xl">{m.name}</h3>
                        <p className="mt-1 text-sm text-muted-foreground">{m.desc}</p>
                      </div>
                      <div className="col-span-4 text-right md:col-span-3">
                        <span className="font-display text-lg md:text-xl">{m.price}</span>
                        <p className="mt-1 font-mono text-[0.65rem] uppercase tracking-[0.14em] text-muted-foreground">{m.duration}</p>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
              <div className="mt-8">
                <BookButton category={c.slug} label={`Book ${c.short}`} testid={`menu-book-${c.slug}`} solid={false} className="!py-3" />
              </div>
            </div>
          );
        })}
      </section>

      <CTABanner />
    </>
  );
}
